import { CarVideoTileProps } from "../types";
import styles from "../ourCars.module.css";
import { MouseEvent } from "react";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { publishModalData, publishModalVisibility } from "../../../../../../redux/features/modal/modalSlice";
import PrizeTicketSelector from "../../../../../../components/PrizeTicketSelector/prizeTicketSelector";

const CarVideoTile = ({
  videoSource,
  make,
  model,
  cashText,
  logoImageSource,
  saleTicketPrice,
  baseTicketPrice,
  carImageSource,
  prizeId,
  hideCashAlternative,
}: CarVideoTileProps) => {
  const dispatch = useAppDispatch();
  const onCarCartClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    dispatch(
      publishModalData({
        modalData: (
          <PrizeTicketSelector
            {...{
              prizeId,
            }}
          />
        ),
      })
    );
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  return (
    <div className="xs:h-[270px] md:h-[290px] relative">
      {/* preload="none" prevents the browser eagerly downloading the MP4 for tiles that are
          off-screen or not yet in view. autoPlay still works for muted inline videos once
          the element enters the viewport. */}
      <video autoPlay loop muted playsInline preload="none" className={styles.videoPlayer}>
        <source src={videoSource} type="video/mp4" />
      </video>
      <div className="absolute top-3 left-3 right-3 bottom-3">
        <h1 className={`${styles.cardTitle} text-white`}>{make}</h1>
        <h2 className={`${styles.cardSubtitle} text-white mt-1`}>{model}</h2>
        <hr className="invisible" />
        <p className={`${styles.cardText} mt-2 text-[#fff] ${cashText === null ? "invisible" : "visible"}`}>
          Or take <b>{cashText}</b> cash
        </p>
        <div className="flex relative mt-3">
          {logoImageSource && (
            <img
              src={logoImageSource}
              alt="logo"
              className="max-w-[120px] max-h-[70px] absolute bottom-0 pb-[.75rem]"
            />
          )}
          <img
            className={`${styles.featuredCarImage} ml-auto md:mr-16 xs:mr-0 xs:max-w-[190px] md:max-w-[250px] invisible`}
            src={carImageSource}
            alt={`${make}-${model}`}
          />
        </div>
        <div className="absolute bottom-0 w-full">
          <div className="flex">
            <span className={`${styles.saleTicketPrice} font-medium text-white`}>{saleTicketPrice}</span>
            <span
              className={`${styles.baseTicketPrice} text-white ${saleTicketPrice ? "line-through" : "font-medium"}`}>
              {baseTicketPrice}
            </span>
            <button className={`${styles.cartButton} ml-auto md:p-[7px] xs:p-[5px]`} onClick={onCarCartClick}>
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.00065 14.5671C5.44268 14.5671 5.8666 14.7427 6.17916 15.0552C6.49172 15.3678 6.66732 15.7917 6.66732 16.2337C6.66732 16.6758 6.49172 17.0997 6.17916 17.4122C5.8666 17.7248 5.44268 17.9004 5.00065 17.9004C4.55862 17.9004 4.1347 17.7248 3.82214 17.4122C3.50958 17.0997 3.33398 16.6758 3.33398 16.2337C3.33398 15.7917 3.50958 15.3678 3.82214 15.0552C4.1347 14.7427 4.55862 14.5671 5.00065 14.5671ZM5.00065 14.5671H14.1673M5.00065 14.5671V2.90039H3.33398M14.1673 14.5671C14.6093 14.5671 15.0333 14.7427 15.3458 15.0552C15.6584 15.3678 15.834 15.7917 15.834 16.2337C15.834 16.6758 15.6584 17.0997 15.3458 17.4122C15.0333 17.7248 14.6093 17.9004 14.1673 17.9004C13.7253 17.9004 13.3014 17.7248 12.9888 17.4122C12.6762 17.0997 12.5007 16.6758 12.5007 16.2337C12.5007 15.7917 12.6762 15.3678 12.9888 15.0552C13.3014 14.7427 13.7253 14.5671 14.1673 14.5671ZM5.00065 4.56706L16.6673 5.40039L15.834 11.2337H5.00065"
                  stroke="#F7F7F7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarVideoTile;
